export default "__VITE_ASSET__ggYs$bzL__"